import Section_SharedTo from './container';

export default Section_SharedTo;



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/index.js